import { BotanicalMark } from './SiteA';

const BUSINESS_NAME = 'Oregon Tea Growers';
const EMAIL = 'hello@oregonteagrowers.com';
const PHONE = '503-395-7395';

const palette = ['#3a4a39', '#2d3a2c', '#f4f1e8', '#7a8470'];
const [moss, , bone, sage] = palette;

export default function HoldingPage() {
  return (
    <div
      data-testid="holding-page"
      className="site"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: bone,
        color: '#1f231d',
        fontFamily: "'Inter', system-ui, sans-serif",
        textAlign: 'center',
        gap: 24,
        '--bone': bone,
      }}
    >
      <BotanicalMark color={sage} size={56} />
      <h1
        style={{
          fontFamily: "'Cormorant Garamond', Georgia, serif",
          fontStyle: 'italic',
          fontWeight: 400,
          fontSize: 'clamp(28px, 5vw, 48px)',
          color: moss,
          margin: 0,
        }}
      >
        {BUSINESS_NAME}
      </h1>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, fontSize: 16 }}>
        <a href={`mailto:${EMAIL}`} style={{ color: moss, textDecoration: 'none' }}>
          {EMAIL}
        </a>
        <a href={`tel:${PHONE}`} style={{ color: moss, textDecoration: 'none' }}>
          {PHONE}
        </a>
      </div>
    </div>
  );
}
